import React from 'react';
import FadeSlideIn from "../../common/FadeSlideIn";
import registerCreatorCode from "../../../resources/registerCreatorCode.png"
import floatingChest from "../../../resources/floatingChest.png"
import floatingChestB from "../../../resources/floatingChestB.png"
import floatingChestC from "../../../resources/floatingChestC.png"

const LandingRegister = () => {
    return (<FadeSlideIn>
        <div className="container landingRegister">

            <div className="landingRegisterWrapper">
                <div className="landingRegisterLeft">
                    <h1>Register Instantly</h1>
                    <p>Register today using code “Nick” and receive exclusive rewards instantly!</p>
                    <ul>
                        <li>Click on the <span className="howlText">Rewards</span> button, then click on “Go to VIP
                            Dashboard”.
                        </li>
                        <li>Once you visit the <span className="howlText">Rewards</span> page, scroll down.</li>
                        <li>Locate the Use Creator Code section and use code "<span className="howlText">Nick</span>"!
                        </li>
                    </ul>
                    <a href="#" className="btn btn-howl">CLAIM REWARDS</a>
                </div>
                <div className="landingRegisterRight">

                <div className="creatorCodeWrapper">
                        <img src={registerCreatorCode} alt=""/>
                        <img src={floatingChest} alt="" className={"floatingChestA floating"}/>
                        <img src={floatingChestB} alt="" className={"floatingChestB floatingB"}/>
                        <img src={floatingChestC} alt="" className={"floatingChestC floatingC"}/>
                    </div>


                </div>
            </div>


        </div>
    </FadeSlideIn>);
}
export default LandingRegister;